import React from 'react';
import PropTypes from 'prop-types';
import { formatNumberToReal } from '../../../utils/formatting';
import * as S from './styles';

export const UIPrice = ({
  price, promotionalPrice, free, smallType,
}) => (
  <S.UIPrice
    smallType={smallType}
    hasPromotionalPrice={(Number(promotionalPrice) > 0) || free}
  >
    {Number(price) > 0 && (
      <span className="price">{formatNumberToReal(price)}</span>
    )}
    {free && (
      <span className="promotional-price">
        GRÁTIS
      </span>
    )}
    {Number(promotionalPrice) > 0 && (
      <span className="promotional-price">
        {formatNumberToReal(promotionalPrice)}
      </span>
    )}
  </S.UIPrice>
);

UIPrice.propTypes = {
  free: PropTypes.bool,
  smallType: PropTypes.bool,
  price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  promotionalPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

UIPrice.defaultProps = {
  free: false,
  smallType: false,
  price: '0.00',
  promotionalPrice: null,
};
